import { Switch, type SwitchProps } from '@headlessui/react';
import { classNames } from '@library/utils';

type PrizepicksSwitchProps = SwitchProps<'div'> & {
  active: boolean;
  className?: string;
  disabled?: boolean;
  handleChange: (value: boolean) => void;
  statType?: string;
  testId?: string;
};

export const PrizepicksSwitch = ({
  active,
  className = '',
  disabled = false,
  handleChange,
  statType = 'switch',
  testId = 'prizepicks-switch'
}: PrizepicksSwitchProps) => {
  const onChange = (newValue: boolean) => {
    handleChange(newValue);
  };

  return (
    <Switch
      aria-disabled={disabled}
      key={`switch-${statType}`}
      checked={active}
      onChange={onChange}
      className={classNames(
        active
          ? 'bg-stankonia-200 border-stankonia-200'
          : 'border-soFresh-140 bg-soFresh-110',
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        'focus:outline-stankonia-100 relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border transition-colors duration-200 ease-in-out',
        className
      )}
      data-testid={testId}
    >
      <div className="size-4">
        <span
          className={classNames(
            active
              ? 'bg-soClean-100 m-[3px] h-4 w-4 translate-x-5'
              : 'bg-soFresh-180 m-[5px] h-3 w-3 translate-x-0',
            'pointer-events-none relative inline-block transform rounded-full shadow ring-0 transition duration-200 ease-in-out'
          )}
        >
          <span
            className={classNames(
              active
                ? 'opacity-0 duration-100 ease-out'
                : 'opacity-100 duration-200 ease-in',
              'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity'
            )}
            aria-hidden="true"
          />
          <span
            className={classNames(
              active
                ? 'opacity-100 duration-200 ease-in'
                : 'opacity-0 duration-100 ease-out',
              'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity'
            )}
            aria-hidden="true"
          >
            <svg
              className="text-stankonia-200 size-3"
              fill="currentColor"
              viewBox="0 0 12 12"
            >
              <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
            </svg>
          </span>
        </span>
      </div>
    </Switch>
  );
};
